/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAlertIntervalTypeFromJSON, ApiAlertIntervalTypeToJSON, } from './ApiAlertIntervalType';
import { ApiAlertNotificationPayloadFromJSON, ApiAlertNotificationPayloadToJSON, } from './ApiAlertNotificationPayload';
import { ApiAlertRequirementPayloadFromJSON, ApiAlertRequirementPayloadToJSON, } from './ApiAlertRequirementPayload';
import { ApiAlertTypeFromJSON, ApiAlertTypeToJSON, } from './ApiAlertType';
export function ApiAlertPayloadFromJSON(json) {
    return ApiAlertPayloadFromJSONTyped(json, false);
}
export function ApiAlertPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chartNotifications': !exists(json, 'chartNotifications') ? undefined : (json['chartNotifications'].map(ApiAlertNotificationPayloadFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'emails': !exists(json, 'emails') ? undefined : json['emails'],
        'interval': !exists(json, 'interval') ? undefined : json['interval'],
        'intervalType': !exists(json, 'intervalType') ? undefined : ApiAlertIntervalTypeFromJSON(json['intervalType']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'requirements': !exists(json, 'requirements') ? undefined : (json['requirements'].map(ApiAlertRequirementPayloadFromJSON)),
        'type': !exists(json, 'type') ? undefined : ApiAlertTypeFromJSON(json['type']),
    };
}
export function ApiAlertPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chartNotifications': value.chartNotifications === undefined ? undefined : (value.chartNotifications.map(ApiAlertNotificationPayloadToJSON)),
        'description': value.description,
        'emails': value.emails,
        'interval': value.interval,
        'intervalType': ApiAlertIntervalTypeToJSON(value.intervalType),
        'name': value.name,
        'requirements': value.requirements === undefined ? undefined : (value.requirements.map(ApiAlertRequirementPayloadToJSON)),
        'type': ApiAlertTypeToJSON(value.type),
    };
}
